import languageDictionary from 'src/app/shared/transloco/default';
import { NestedPropertyOf } from 'src/app/shared/transloco/types/nested-key-of.type';

export enum RoleMenuSet {
    Maintenance = 'maintenanceRoleMenuSet',
    Operator = 'observerRoleMenuSet',
    Specialist = 'specialistRoleMenuSet',
}

export const RoleMenu: { value: RoleMenuSet; name: NestedPropertyOf<typeof languageDictionary> }[] = [
    { value: RoleMenuSet.Maintenance, name: 'properties.roles.actions.maintenance' },
    { value: RoleMenuSet.Operator, name: 'properties.roles.actions.operator' },
    { value: RoleMenuSet.Specialist, name: 'properties.roles.actions.specialist' },
];
